import { useState } from 'react'
import { CodeFromEmail } from '../components/LandingPage/ResetPassword/CodeFromEmail'
import { ResetPassword } from '../components/LandingPage/ResetPassword/ResetPassword'
import { SentViaEmail } from '../components/LandingPage/ResetPassword/SentViaEmail'

export const ForgotPassword = () => {
  const [step, setStep] = useState<'email' | 'code' | 'password'>('email')
  const [email, setEmail] = useState<string>('')
  const [code, setCode] = useState<number | null>(null)

  const _renderForm = () => {
    if (step === 'email') {
      return <SentViaEmail setStep={setStep} setEmail={setEmail} />
    } else if (step === 'code') {
      return <CodeFromEmail email={email} setCode={setCode} setStep={setStep} />
    } else if (step === 'password') {
      return <ResetPassword email={email} setStep={setStep} code={code} />
    }
  }

  return (
    <div className='login-bg1 w-full font-dashboard bg-[#f8f8f8] h-screen flex justify-center items-center'>
      {_renderForm()}
    </div>
  )
}
